import { render, staticRenderFns } from "./ObservationTable.vue?vue&type=template&id=3c22cf64&"
import script from "./ObservationTable.vue?vue&type=script&lang=js&"
export * from "./ObservationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports